module.exports = __webpack_public_path__ + "static/kerry_stuffed_toy-9fc8448b094b76bd8aa895e6133c5fe2.jpg";